export enum DotsColor {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    HEADING = 'heading',
    SUBHEADING = 'subheading',
    SUCCESS = 'success',
    ALERT = 'alert',
    WARNING = 'warning',
    DISABLED = 'disabled',
    LINK = 'link',
    NEUTRAL = 'neutral',
    PLACEHOLDER = 'placeholder'
}

export type DotsColorType = `${DotsColor}`

export interface DotsProps {
    /**
     * Variant of dots to display
     * @default 'dark'
     */
    variant?: 'dark' | 'light'

    /**
     * Size of the dots
     * @default 'medium'
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * Speed of the animation
     * @default 'normal'
     */
    speed?: 'slow' | 'normal' | 'fast'

    /**
     * Custom color for the dots
     */
    color?: DotsColorType

    /**
     * Custom class name
     */
    className?: string

    /**
     * Test ID for testing
     */
    dataTestId?: string
}
